<!-- ワンタイムコード入力して、認証失敗 -->
<template>
  <ItemDialog ref="OnetimeCodeFails" image-type="alert">
    <template #content-area>
      <h2>
        {{ $t("MyTicketTicketing.passCodeFailed.title") }}
      </h2>
      <p class="text-center">
        もう一度ご入力いただくか、ワンタイムパスワードを今一度ご確認ください。
      </p>
    </template>
    <template #button-area>
      <ItemButton label="OK" action-type="btn-primary" @clicked="closeDialog" />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogOnetimeCodeFails",
  setup(_, context) {
    const OnetimeCodeFails = ref();

    const openDialog = async () => {
      OnetimeCodeFails.value.open();
    };

    const closeDialog = async () => {
      OnetimeCodeFails.value.close();
      context.emit("clearInputedCode");
    };

    return {
      OnetimeCodeFails,
      openDialog,
      closeDialog,
    };
  },
};
</script>
